import { useNavigate } from 'react-router-dom';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function InfoNotFound({ onClose }: ModalProps) {
  const navigate = useNavigate();
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>정보 조회 불가</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            입력하신 전화번호로 <br />
            사전 예약 이력이 없습니다.
          </S.Summary>
          <S.Summary>예약 내역을 재확인해주세요.</S.Summary>
        </S.ModalContent>
        <S.CloseButton
          type="button"
          onClick={() => {
            onClose();
            navigate('/');
          }}
        >
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
